import { useObjectUrl } from "./useObjectUrl";

export interface IImagePreviewModal {
  imageSrc?: File;
  imageUrl?: string;
}

export default function ImagePreviewModal({ imageSrc, imageUrl }: IImagePreviewModal) {
  const objectUrl = useObjectUrl(imageSrc);
  const src = objectUrl || imageUrl;

  if (!src) return <></>;

  return (
    <div className="absolute bottom-0 right-0 origin-bottom-right overflow-clip inline-flex  h-[60%] w-[60%] justify-end items-end z-50">
      <img
        className="min-h-[60%] min-w-[60%] max-h-full max-w-full border-4 object-contain border-brij-Blue "
        src={src}
      />
    </div>
  );
}
